<template>
  <div class="modal-window">
    <div class="modal-content">
      <div class="modal-body">
        <div v-if="title" class="modal-title">
          <slot name="modalTitle"> {{ title }}</slot>
        </div>
        <div v-if="message" class="modal-message">
          <slot name="modalMessage">
            <img
              v-if="logo"
              src="../../../public/images/tes-new-pdf-logo.jpg"
              width="20%"
              height="20%"
            />
            <h2 v-if="welcome">{{ $t('components.updateModal.welcome') }}</h2>
            <div v-if="highlight" class="highlight">{{ highlight }}</div>
            <div v-if="typeof message === 'object'" class="otp">
              <p v-for="(item, idx) in message" :key="idx">
                {{ item }}
              </p>
            </div>
            <div v-else>
              {{ message }}
            </div>
          </slot>
        </div>
        <div class="modal-data">
          <slot name="modalData"></slot>
        </div>
      </div>
      <div v-if="footer" class="modal-footer">
        <div class="btn">
          <div class="button" @click="doSpecialMsgClick()">
            Ok
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpdateModal',
  props: {
    title: {
      type: String,
      default: ''
    },
    message: {
      type: [String, Object],
      default: ''
    },
    highlight: {
      type: String,
      default: ''
    },
    logo: {
      type: Boolean,
      default: false
    },
    welcome: {
      type: Boolean,
      default: null
    },
    footer: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    doSpecialMsgClick() {
      this.$emit('continue-action');
    },
    escapeHtml(unsafe) {
      return unsafe
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.modal-window {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: $slate-grey-transparent;
  z-index: 999;

  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  transition: all 0.3s;
}

.modal-content {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  color: $black-grey;

  .modal-body {
    display: flex;
    flex-direction: column;
  }
  .modal-actions {
    display: flex;
    justify-content: center;
  }

  .modal-footer {
    display: flex;
    padding: 10px;
    background-color: $white;
    justify-content: flex-end;
    .btn {
      display: flex;
      justify-self: flex-end;
      .button {
        display: flex;
        justify-content: center;
        align-items: center;
        color: $white;
        background-color: $blue;
        width: 120px;
        padding: 15px;
        &:hover {
          cursor: pointer;
        }
      }
    }
  }
}

.modal-title {
  font-size: 1.5rem;
  font-weight: 400;
  padding-bottom: 0.5rem;
}

.modal-message {
  padding: 30px;
  background-color: $white;

  .highlight {
    font-weight: bold;
    border-bottom: 1px solid $blue;
  }
  h2 {
    margin-top: 10px;
  }
}
.modal-data {
  display: flex;
  width: 100%;
  font-weight: bold;
  justify-content: center;
}

.comment {
  display: block;
  padding-left: 40px;
  padding-bottom: 10px;
  label {
    padding-right: 5px;
  }
}

.comment-value {
  display: inline-block;
  width: 75%;
}
</style>
